import { Component, Input } from '@angular/core';
import { AppRoutingService } from '@ui-components/services';


@Component({
  selector: 'lib-container',
  templateUrl: './container.component.html',
  styleUrl: './container.component.scss'
})
export class LibContainerComponent {

  @Input() title: string = '';

}
